// extracted by mini-css-extract-plugin
module.exports = {"container":"Button-module--container--2fW50","outline":"Button-module--outline--25AD2","delete":"Button-module--delete--32BEr"};